export default __webpack_public_path__ + "static/media/carpool.2f08e5dd.png";